module.exports = __webpack_public_path__ + "fonts/Satoshi-Light.37a0939.woff2";